// Shared platform footer, used by Portal, Fund, Reader and Shop.
//
// The one editable copy is antarcticpress-platform-hosting/src/shared/Footer.js.
// The Fund, Reader and Shop build scripts (scripts/build_{fund,reader,shop}.sh)
// overwrite each app's own Footer.js with it before building, so edits there
// reach every app on the next deploy. scripts/sync_shared.sh refreshes the
// committed copies in the app repos that local dev uses.
//
// Keep this file self-contained: it is dropped into four different React apps,
// so it may import nothing but React.
//
// The legal pages are served by the Portal at root-level paths. Every link is a
// plain <a href> because it crosses SPA boundaries — never a router <Link>.
import React from "react";

const LEGAL_LINKS = [
  { label: "Trust & Safety", href: "/trust-and-safety" },
  { label: "Terms of Use", href: "/terms-of-use" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Refund Policy", href: "/refund-policy" },
  { label: "Accessibility Statement", href: "/accessibility-statement" },
];

const Footer = ({ style }) => {
  return (
    <footer style={{ ...footerStyle, ...style }}>
      <ul style={listStyle}>
        {LEGAL_LINKS.map(({ label, href }) => (
          <li key={href}>
            <a href={href} style={linkStyle}>{label}</a>
          </li>
        ))}
      </ul>
    </footer>
  );
};

const footerStyle = {
  marginTop: "60px",
  padding: "20px",
  borderTop: "1px solid #ddd",
  backgroundColor: "#f1f1f1",
  textAlign: "center",
};

const listStyle = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  listStyle: "none",
  gap: "20px",
  padding: 0,
  margin: 0,
};

const linkStyle = {
  color: "#114c96",
  textDecoration: "none",
  fontSize: "14px",
};

export default Footer;
